/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ReportStateRequestBody,
  ReportStateRequestBody$Outbound,
  ReportStateRequestBody$outboundSchema,
} from "../components/reportstaterequestbody.js";

export type ReportAgentStateSecurity = {
  apikeyHeaderGramKey?: string | undefined;
};

export type ReportAgentStateRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Email of the enrolled user, sent in the Gram-User-Email header. Authoritative when authenticating with an org-scoped agent install key (the MDM zero-touch path); ignored for a per-user key, whose owner is the enrolled user.
   */
  gramUserEmail?: string | undefined;
  /**
   * Hardware serial number of the reporting machine, when the agent can read it.
   */
  gramDeviceSerial?: string | undefined;
  /**
   * Hostname of the reporting machine, when the agent can read it.
   */
  gramDeviceHostname?: string | undefined;
  /**
   * What kind of machine the agent runs on, as in getPlugins: endpoint (the default when omitted), ephemeral, or server.
   */
  gramDeviceEnvironment?: string | undefined;
  reportStateRequestBody: ReportStateRequestBody;
};

/** @internal */
export type ReportAgentStateSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ReportAgentStateSecurity$outboundSchema: z.ZodMiniType<
  ReportAgentStateSecurity$Outbound,
  ReportAgentStateSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function reportAgentStateSecurityToJSON(
  reportAgentStateSecurity: ReportAgentStateSecurity,
): string {
  return JSON.stringify(
    ReportAgentStateSecurity$outboundSchema.parse(reportAgentStateSecurity),
  );
}

/** @internal */
export type ReportAgentStateRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-User-Email"?: string | undefined;
  "Gram-Device-Serial"?: string | undefined;
  "Gram-Device-Hostname"?: string | undefined;
  "Gram-Device-Environment"?: string | undefined;
  ReportStateRequestBody: ReportStateRequestBody$Outbound;
};

/** @internal */
export const ReportAgentStateRequest$outboundSchema: z.ZodMiniType<
  ReportAgentStateRequest$Outbound,
  ReportAgentStateRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramUserEmail: z.optional(z.string()),
    gramDeviceSerial: z.optional(z.string()),
    gramDeviceHostname: z.optional(z.string()),
    gramDeviceEnvironment: z.optional(z.string()),
    reportStateRequestBody: ReportStateRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramUserEmail: "Gram-User-Email",
      gramDeviceSerial: "Gram-Device-Serial",
      gramDeviceHostname: "Gram-Device-Hostname",
      gramDeviceEnvironment: "Gram-Device-Environment",
      reportStateRequestBody: "ReportStateRequestBody",
    });
  }),
);

export function reportAgentStateRequestToJSON(
  reportAgentStateRequest: ReportAgentStateRequest,
): string {
  return JSON.stringify(
    ReportAgentStateRequest$outboundSchema.parse(reportAgentStateRequest),
  );
}
